import { render } from "./ClubFAQ.vue?vue&type=template&id=3b674cb0&scoped=true"
import script from "./ClubFAQ.vue?vue&type=script&lang=js"
export * from "./ClubFAQ.vue?vue&type=script&lang=js"

import "./ClubFAQ.vue?vue&type=style&index=0&id=3b674cb0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b674cb0"]])

export default __exports__